import { render, staticRenderFns } from "./FormPortals.vue?vue&type=template&id=6f2e9f33"
import script from "./FormPortals.vue?vue&type=script&lang=js"
export * from "./FormPortals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports